import { z } from 'zod';

import {
  MatterStatus,
  MatterType,
  SimplifiedBillingCode,
} from '../../services/types/client-intake-types';

// Schema for form validation
export const createMatterSchema = z.object({
  name: z.string().min(1, 'Matter name is required'),
  matter_type: z.nativeEnum(MatterType).optional(),
  status: z.nativeEnum(MatterStatus).optional(),
  date_of_loss: z.string().optional(),
  statute_of_limitations_date: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  phoneNumber: z.string().optional(),
  contact_client_directly: z.boolean().optional(),
  firm: z.object({
    id: z.string().min(1, 'Firm is required'),
    name: z.string(),
  }),
  representing_attorney: z.string().uuid().nullable().optional(),
  external_cms_url: z.string().url().nullish(),
  external_drive_url: z.string().url().nullish(),
  cms_email: z.string().email().nullish(),
  case_id: z.string().nullish(),
  case_manager_id: z.string().uuid().nullable().optional(),
  /** Whether MP tasks should be auto-assigned to the case manager */
  auto_task_assignment: z.boolean().optional(),
  simplified_billing_code: z
    .nativeEnum(SimplifiedBillingCode)
    .nullable()
    .optional(),
});
